import Gravity from 'Gravity';

const teamMembersWithPopUpClass = 'gg-team-members-popup-with-filters';
const teamMembersWithPopUpClassModules = document.querySelectorAll(`.${teamMembersWithPopUpClass}`);

const addActionsToPopupButtons = (module) => {
    const resultContainerClass = 'posts-result__container';
    const popUp = module.querySelector(`.${teamMembersWithPopUpClass}__popup`);
    const dynamicBoxes = module.querySelector('.gravity-block-dynamic-boxes');
    const closeButton = module.querySelector(`.wp-block-buttons .${teamMembersWithPopUpClass}__popup-close`);
    const closeButtonWrap = module.querySelector(`.wp-block-buttons`);
    const isOutsidePopup = module.querySelector(
        `.${teamMembersWithPopUpClass}__popup-wrapper .wp-block-cover__background`
    );
    const popUpDynamicBoxes = module.querySelector(`.${teamMembersWithPopUpClass}__popup .gravity-block-dynamic-boxes`);
    const popUpResultsContainer = popUpDynamicBoxes.querySelector(`.${resultContainerClass}`);
    const select = module.querySelector('.gravity-block-filters__select');

    if (!popUp || !dynamicBoxes || !popUpDynamicBoxes) {
        return;
    }

    const openPopUp = ({ target }) => {
        const postId = target.closest('.gravity-block-dynamic-boxes__box').getAttribute('data-post-id');

        if (!postId) {
            return;
        }

        module.classList.add('show-popup');
        document.addEventListener(`focus`, Gravity.trapFocusHandler(popUp), true);
        Gravity.toggleBodyOverflow();
        updateMemberInfo(postId);
    };

    const closePopUp = () => {
        module.classList.remove('show-popup');
        Gravity.toggleBodyOverflow();
        document.removeEventListener(`focus`, Gravity.trapFocusHandler(popUp), true);
    };

    const updateMemberInfo = (postId) => {
        popUpResultsContainer.innerHTML = null;
        popUpDynamicBoxes.classList.add('is-loading');

        getTeamMemberInfo(popUpDynamicBoxes, postId).then((response) => {
            if (!response.success || !response.data.html) {
                return;
            }

            popUpDynamicBoxes.classList.remove('is-loading');
            popUpResultsContainer.innerHTML = response.data.html;
        });
    };

    const getTeamMemberInfo = async (dynamicBoxesBlock, postId) => {
        // eslint-disable-next-line consistent-return

        if (dynamicBoxesBlock) {
            const blockSettings = dynamicBoxesBlock.dataset.blockSettings || null;
            const blockArgs = JSON.stringify({
                p: postId,
                post_status: 'publish',
                posts_per_page: '1',
                post_type: 'team',
            });

            const formData = new FormData();
            formData.append('action', 'filter_dynamic_box');
            formData.append('nonce', window.gravityBlocksGlobalVars.nonce);
            formData.append('blockArgs', blockArgs);
            formData.append('blockSettings', blockSettings);
            formData.append('paged', 1);
            formData.append('post_id', window.gravityBlocksGlobalVars.postId);

            try {
                const response = await fetch(window.gravityBlocksGlobalVars.ajaxUrl, {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: formData,
                });

                // eslint-disable-next-line consistent-return
                return response.json();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        }
        return false;
    };

    // Add event listeners to: mouse click, Enter
    if(closeButton) {
        Gravity.clickEnterListener(closeButton, closePopUp);
    } else {
        Gravity.clickEnterListener(closeButtonWrap, closePopUp);
    }

    // close popup on click outside

    Gravity.clickEnterListener(isOutsidePopup, closePopUp);

    const addActionToOpenButtons = () => {
        const openButtons = module.querySelectorAll(`.${teamMembersWithPopUpClass}__open-popup`);
        openButtons.forEach((button) => {
            button.addEventListener('click', openPopUp);
        });
    };
    addActionToOpenButtons();

    // support for boxes change (Filters/ Load More)
    dynamicBoxes.addEventListener('gg-boxes-loaded', () => {
        addActionToOpenButtons();
    });

    const selectFix = async () => {
        if (!select) {
            return;
        }

        select.addEventListener('change', (e) => {
            setTimeout(
                (eTarget) => {
                    eTarget.classList.remove('active');
                },
                0,
                e.target
            );
        });
    };

    selectFix();
};

const includeTermsToDropdown = (module) => {
    if (!module && !module.dataset.includedItems) {
        return;
    }

    const includedOptions = module.dataset.includedItems.split(',');
    const filterDropdownOptions = document.querySelectorAll('.gravity-block-filters__option');
    filterDropdownOptions.forEach((option) => {
        const dropdownOption = option.getAttribute('value').replace(/&amp;/g, '&');
        if (!includedOptions.includes(dropdownOption)) {
            option.setAttribute('disabled', true);
            // eslint-disable-next-line no-param-reassign
            option.style.display = 'none';
        }
    });
};

Gravity.ready(() => {
    teamMembersWithPopUpClassModules.forEach((module) => {
        addActionsToPopupButtons(module);
        includeTermsToDropdown(module);
    });
});
